var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitCard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 39,
    height: 39,
    fill: "#E2DEFF",
    stroke: "#4A03A5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "#4A03A5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    width: 7,
    height: 7,
    fill: "#4A03A5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 39,
    width: 7,
    height: 7,
    fill: "#4A03A5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 39,
    width: 7,
    height: 7,
    fill: "#4A03A5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.89 13.8801L20.2 13.1401C16.29 12.5301 14.48 13.8501 13.86 17.7601L13.12 22.4501C12.72 25.0101 13.14 26.6701 14.59 27.6801C15.35 28.2201 16.39 28.5801 17.74 28.7901L22.43 29.5301C26.34 30.1401 28.15 28.8201 28.77 24.9101L29.5 20.2201C29.62 19.4501 29.67 18.7601 29.63 18.1501C29.5 15.6501 28.03 14.3701 24.89 13.8801ZM19.24 20.3501C18.07 20.3501 17.12 19.4001 17.12 18.2401C17.12 17.0701 18.07 16.1201 19.24 16.1201C20.4 16.1201 21.35 17.0701 21.35 18.2401C21.35 19.4001 20.4 20.3501 19.24 20.3501Z",
    fill: "#4A03A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5006 24.4705L30.0006 28.9805C28.7506 32.7405 26.7506 33.7405 22.9906 32.4905L18.4806 30.9905C17.0706 30.5205 16.0506 29.9405 15.3906 29.2105C16.0206 29.4605 16.7506 29.6505 17.5806 29.7805L22.2806 30.5205C22.9206 30.6205 23.5206 30.6705 24.0806 30.6705C27.3806 30.6705 29.1506 28.8905 29.7606 25.0605L30.4906 20.3705C30.5906 19.7905 30.6306 19.2805 30.6306 18.8105C32.1506 20.0605 32.3706 21.8405 31.5006 24.4705Z",
    fill: "#4A03A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitCard1);
export default __webpack_public_path__ + "static/media/benefit-card-1.f5e352b5f8121341ba81c6398a9062ae.svg";
export { ForwardRef as ReactComponent };